import { consoleApiSlice } from "./consoleApiSlice";

export const consoleScansApiSlice = consoleApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getConsoleScanById: builder.query({
      query: (scanId) => `/scans/${scanId}`,
      providesTags: (result, error, scanId) => [{ type: "Scans", id: scanId }],
    }),
    getConsoleIssuesByScanId: builder.query({
      query: (scanId) => `/scans/${scanId}/issues`,
      providesTags: (result, error, scanId) => [
        { type: "Issues", id: scanId },
        "Issues",
      ],
    }),
    createConsoleScan: builder.mutation({
      query: (scan) => ({
        url: "/scans",
        method: "POST",
        body: scan,
      }),
      invalidatesTags: ["Scans"],
    }),
    updateConsoleScan: builder.mutation({
      query: ({ scanId, scan }) => ({
        url: `/scans/${scanId}`,
        method: "PUT",
        body: scan,
      }),
      invalidatesTags: (result, error, { scanId }) => [
        { type: "Scans", id: scanId },
        "Scans",
      ],
    }),
    deleteConsoleScan: builder.mutation({
      query: (scanId) => ({
        url: `/scans/${scanId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Scans"],
    }),
    consolidateConsoleScan: builder.mutation({
      query: ({ scanId, useProd, targetWebsiteId }) => ({
        url: "/scans/consolidate",
        method: "POST",
        body: {
          scan_id: scanId,
          use_prod: useProd,
          target_website_id: targetWebsiteId,
        },
      }),
      invalidatesTags: ["Scans"],
    }),
  }),
});

export const {
  useGetConsoleScanByIdQuery,
  useGetConsoleIssuesByScanIdQuery,
  useCreateConsoleScanMutation,
  useUpdateConsoleScanMutation,
  useDeleteConsoleScanMutation,
  useConsolidateConsoleScanMutation,
} = consoleScansApiSlice;
